// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/img/logo.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UoU1u{align-items:center;color:var(--anchore-color-blue-400);display:inline-flex;flex-shrink:0;gap:.3rem;line-height:1}.UoU1u .LAQvb{background-color:currentcolor;-webkit-mask-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});mask-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});-webkit-mask-position:center;mask-position:center;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-size:contain;mask-size:contain;width:4rem}.UoU1u .RletR,.UoU1u .LAQvb{display:block;height:1rem}.UoU1u .RletR{width:1rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `UoU1u`,
	"logo": `LAQvb`,
	"icon": `RletR`
};
module.exports = ___CSS_LOADER_EXPORT___;
